import commonConstant from '../../common/_commonConstant';
import { getCookieToken, checkTimeToRefreshToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchCreatePayment = fromPayment => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/payments/payment-by-users`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'POST',
        'body': JSON.stringify(fromPayment),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.CREATE_PAYMENT_SUCCESS,
          'data': data.data ? { ...data.data, 'metadata': { ...data.metadata } } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.CREATE_PAYMENT_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.CREATE_PAYMENT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.CREATE_PAYMENT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchUpdatePayment = paymentID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/payments/${paymentID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
        'method': 'PUT',
        'body': JSON.stringify({ 'paymentStatus': commonConstant.paymentStatusPaid }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.UPDATE_PAYMENT_SUCCESS,
          'data': data.data ? { ...data.data } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.UPDATE_PAYMENT_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.UPDATE_PAYMENT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.UPDATE_PAYMENT_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);

export const fetchGetPaymentDetail = paymentID => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/payments/${paymentID}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }

      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_PAYMENT_DETAIL_SUCCESS,
          'data': data.data ? {
            ...data.data,
            'gatewayErrorReason': data.data.gatewayErrorReason ? JSON.parse(data.data.gatewayErrorReason) : '',
          } : {},
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': null,
        });
      } else if (res.status === 400) {
        return dispatch({
          'type': commonConstant.GET_PAYMENT_DETAIL_FAILURE,
          'data': null,
          'dateTime': new Date(),
          'status': res.status,
          'errorMessage': data.detail,
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_PAYMENT_DETAIL_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': res.status ? res.status : res,
        'errorMessage': data.detail ? data.detail : data,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_PAYMENT_DETAIL_FAILURE,
        'data': null,
        'dateTime': new Date(),
        'status': err.status ? err.status : err,
        'errorMessage': null,
      });
    }
  }
);


